import React from 'react';
import { bool, shape, string } from 'prop-types';

const CropColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.57812 10.263C3.68021 9.95669 3.96681 9.75012 4.28964 9.75012H13.361C13.6703 9.75012 13.9479 9.94001 14.06 10.2283L16.1017 15.4783C16.2929 15.9699 15.9302 16.5001 15.4027 16.5001H2.53964C2.02772 16.5001 1.66624 15.9986 1.82812 15.513L3.57812 10.263ZM12.7491 11.2501H4.87407L3.74907 15.0001H14.2491L12.7491 11.2501Z" fill="currentColor" />
    <path d="M8.24907 12.9753H9.74907V7.60986L8.93754 7.60972L8.24907 7.53528V12.9753Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.97101 3.78883C6.78392 3.86131 7.55353 4.10667 7.98523 4.6457C8.49004 5.27602 8.74473 6.15925 8.86167 6.95171C8.898 7.19789 8.91976 7.42627 8.93252 7.62288C8.79434 7.6193 8.64025 7.60927 8.47595 7.58877C7.82296 7.50733 7.06698 7.26915 6.47593 6.67816C5.872 6.07427 5.53947 5.2043 5.36529 4.42004C5.31243 4.18205 5.27593 3.96005 5.25077 3.76736C5.46375 3.76189 5.71042 3.7656 5.97101 3.78883ZM8.94163 7.61808C8.97766 7.52716 9.0185 7.43147 9.06463 7.33263C9.35496 6.71052 9.83309 6.00881 10.599 5.54926C11.3319 5.10953 12.0656 5.10395 12.6442 5.21964C12.7663 5.24407 12.8801 5.2737 12.9834 5.30521C12.9173 5.44278 12.8393 5.594 12.7496 5.75072C12.397 6.36717 11.9262 6.95845 11.377 7.23372C10.7839 7.53106 9.98698 7.62438 9.27542 7.62458C9.15875 7.62461 9.04691 7.62216 8.94163 7.61808Z" fill="currentColor" />
  </svg>
);

CropColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default CropColor;
